import React, {useEffect, useState} from 'react';
import TaskTypeEditorTemplate from './TaskTypeEditorTemplate';
import taskTypeService from '../../services/TaskTypeService';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../dashboard/TitleContext';

const TaskTypeEditor = () => {

    const id = window.location.pathname.split('/')[3] === 'create' ? undefined : window.location.pathname.split('/')[3]

    useTitle([
        {name: 'Feladatkör Lista', url: '/dashboard/task-types'},
        {name: 'Feladatkör', url: '/dashboard/task-types/' + (id || 'create')}
    ])

    const [tasktype, setTaskType] = useState({
        name: "",
        paymentModifier: "",
        paymentCategory: "",
        createdAt: "",
        updatedAt: ""
    });

    const [message, setMessage] = useState('');

    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return
        taskTypeService.findById(id)
            .then(response => setTaskType(response))
            .catch(error => console.error(error))
    }, [id]);

    const onChange = (event) => {
        const {name, value} = event.target;
        setTaskType((prevTaskType) => ({
            ...prevTaskType,
            [name]: value,
        }));
    };

    const create = (e) => {
        e.preventDefault();
        taskTypeService.createTaskType(tasktype)
            .then(() => navigate('/dashboard/task-types'))
            .catch(error => setMessage(error.message))
    };

    const update = (e) => {
        e.preventDefault();
        taskTypeService.updateTaskType(id, tasktype)
            .then(() => navigate('/dashboard/task-types'))
            .catch(error => setMessage(error.message))
    };

    return (
        <TaskTypeEditorTemplate
            data={{
                id,
                tasktype,
                message,
                onChange,
                create,
                update,
            }}
        />
    );
};

export default TaskTypeEditor;
